// import React, { useState } from 'react';
// import { motion } from 'motion/react';
// import { useInView } from 'react-intersection-observer';
// import { Clock, Headphones, Rocket, Send } from 'lucide-react';

// export function Contact() {
//   const [ref, inView] = useInView({
//     triggerOnce: true,
//     threshold: 0.2,
//   });

//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     phone: '',
//     message: '',
//   });

//   const [isSubmitting, setIsSubmitting] = useState(false);

//   const handleSubmit = async (e: React.FormEvent) => {
//     e.preventDefault();
//     setIsSubmitting(true);

//     // Simulate form submission
//     await new Promise(resolve => setTimeout(resolve, 1500));

//     alert('Thank you for contacting us! We\'ll get back to you soon.');
//     setFormData({ name: '', email: '', phone: '', message: '' });
//     setIsSubmitting(false);
//   };

//   const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
//     setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
//   };

//   const infoCards = [
//     {
//       icon: Clock,
//       title: 'Quick Response',
//       description: 'Within 24 hours',
//       color: 'from-blue-500 to-cyan-500',
//     },
//     {
//       icon: Headphones,
//       title: 'Expert Support',
//       description: 'Always here to help',
//       color: 'from-purple-500 to-pink-500',
//     },
//     {
//       icon: Rocket,
//       title: 'Fast Setup',
//       description: 'Get started instantly',
//       color: 'from-orange-500 to-red-500',
//     },
//   ];

//   return (
//     <section id="contact" className="py-20 lg:py-32 px-4 sm:px-6 lg:px-20 relative overflow-hidden">
//       <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-accent/5 to-secondary/5 dark:from-primary/10 dark:via-accent/10 dark:to-secondary/10" />

//       <div className="max-w-7xl mx-auto relative">
//         <motion.div
//           ref={ref}
//           initial={{ opacity: 0, y: 30 }}
//           animate={inView ? { opacity: 1, y: 0 } : {}}
//           transition={{ duration: 0.6 }}
//           className="text-center mb-16"
//         >
//           <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-4">
//             Let's Connect &{' '}
//             <span className="bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
//               Create Together
//             </span>
//           </h2>
//           <p className="text-lg text-muted-foreground">
//             Ready to transform your business networking?
//           </p>
//           <p className="text-lg text-muted-foreground mt-2 max-w-3xl mx-auto">
//             Experience the power of NFC technology with custom-designed cards tailored to your needs. 
//             Get in touch today and take your business to new heights.
//           </p>
//         </motion.div>

//         <div className="grid lg:grid-cols-2 gap-12 lg:gap-16">
//           {/* Contact Form */}
//           <motion.div
//             initial={{ opacity: 0, x: -50 }}
//             animate={inView ? { opacity: 1, x: 0 } : {}}
//             transition={{ delay: 0.2, duration: 0.8 }}
//           >
//             <form onSubmit={handleSubmit} className="space-y-6">
//               <div>
//                 <label htmlFor="name" className="block text-sm font-medium text-foreground mb-2">
//                   Full Name
//                 </label>
//                 <input
//                   type="text"
//                   id="name"
//                   name="name"
//                   value={formData.name}
//                   onChange={handleChange}
//                   required
//                   className="w-full px-4 py-3 bg-card border border-border rounded-xl text-foreground placeholder-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all"
//                   placeholder="John Doe"
//                 />
//               </div>

//               <div>
//                 <label htmlFor="email" className="block text-sm font-medium text-foreground mb-2">
//                   Email Address
//                 </label>
//                 <input
//                   type="email"
//                   id="email"
//                   name="email"
//                   value={formData.email}
//                   onChange={handleChange}
//                   required
//                   className="w-full px-4 py-3 bg-card border border-border rounded-xl text-foreground placeholder-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all"
//                   placeholder="john@example.com"
//                 />
//               </div>

//               <div>
//                 <label htmlFor="phone" className="block text-sm font-medium text-foreground mb-2">
//                   Phone Number
//                 </label>
//                 <input
//                   type="tel"
//                   id="phone"
//                   name="phone"
//                   value={formData.phone}
//                   onChange={handleChange}
//                   className="w-full px-4 py-3 bg-card border border-border rounded-xl text-foreground placeholder-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all"
//                   placeholder="+1 (555) 123-4567"
//                 />
//               </div>

//               <div>
//                 <label htmlFor="message" className="block text-sm font-medium text-foreground mb-2">
//                   Message
//                 </label>
//                 <textarea
//                   id="message"
//                   name="message"
//                   value={formData.message}
//                   onChange={handleChange}
//                   required
//                   rows={5}
//                   className="w-full px-4 py-3 bg-card border border-border rounded-xl text-foreground placeholder-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all resize-none"
//                   placeholder="Tell us about your needs..."
//                 />
//               </div>

//               <motion.button
//                 type="submit"
//                 disabled={isSubmitting}
//                 className="w-full px-8 py-4 bg-gradient-to-r from-primary to-accent text-white rounded-xl font-semibold shadow-lg hover:shadow-2xl hover:shadow-primary/50 dark:hover:shadow-primary/30 transition-all duration-300 flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
//                 whileHover={{ scale: isSubmitting ? 1 : 1.02, y: isSubmitting ? 0 : -2 }}
//                 whileTap={{ scale: isSubmitting ? 1 : 0.98 }}
//               >
//                 {isSubmitting ? (
//                   <>
//                     <motion.div
//                       className="w-5 h-5 border-2 border-white border-t-transparent rounded-full"
//                       animate={{ rotate: 360 }}
//                       transition={{ duration: 1, repeat: Infinity, ease: 'linear' }}
//                     />
//                     Sending...
//                   </>
//                 ) : (
//                   <>
//                     Send Message
//                     <Send className="w-5 h-5" />
//                   </>
//                 )}
//               </motion.button>
//             </form>
//           </motion.div>

//           {/* Info Cards */}
//           <motion.div
//             initial={{ opacity: 0, x: 50 }}
//             animate={inView ? { opacity: 1, x: 0 } : {}}
//             transition={{ delay: 0.4, duration: 0.8 }}
//             className="space-y-6"
//           >
//             {infoCards.map((card, index) => (
//               <motion.div
//                 key={card.title}
//                 initial={{ opacity: 0, y: 20 }}
//                 animate={inView ? { opacity: 1, y: 0 } : {}}
//                 transition={{ delay: 0.5 + index * 0.1 }}
//                 whileHover={{ x: 8, scale: 1.02 }}
//                 className="group bg-card border border-border rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all duration-300"
//               >
//                 <div className="flex items-start gap-4">
//                   <motion.div
//                     className={`w-14 h-14 flex-shrink-0 rounded-xl bg-gradient-to-br ${card.color} p-3 shadow-lg`}
//                     whileHover={{ scale: 1.1, rotate: 5 }}
//                     transition={{ type: 'spring', stiffness: 300 }}
//                   >
//                     <card.icon className="w-full h-full text-white" />
//                   </motion.div>

//                   <div className="flex-1">
//                     <h3 className="text-xl font-bold text-foreground mb-1">
//                       {card.title}
//                     </h3>
//                     <p className="text-muted-foreground">
//                       {card.description}
//                     </p>
//                   </div>
//                 </div>

//                 {/* Glow Effect */}
//                 <div className="absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 blur-xl bg-gradient-to-br from-primary/10 to-accent/10 -z-10" />
//               </motion.div>
//             ))}
//           </motion.div>
//         </div>
//       </div>
//     </section>
//   );
// }





import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Clock, Headphones, Rocket, Send } from 'lucide-react';

const infoCards = [
  { icon: Clock, title: 'Quick Response', description: 'Within 24 hours', gradient: ['#3b82f6', '#06b6d4'] },
  { icon: Headphones, title: 'Expert Support', description: 'Always here to help', gradient: ['#8b5cf6', '#ec4899'] },
  { icon: Rocket, title: 'Fast Setup', description: 'Get started instantly', gradient: ['#f97316', '#ef4444'] },
];

const Contact = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.2 });
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1024);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    await new Promise(resolve => setTimeout(resolve, 1500));
    alert("Thank you for contacting us! We'll get back to you soon.");
    setFormData({ name: '', email: '', phone: '', message: '' });
    setIsSubmitting(false);
  };

  return (
    <section
      ref={ref}
      style={{
        position: 'relative',
        padding: '80px 16px',
        overflow: 'hidden',
        background: 'linear-gradient(to bottom, rgba(118, 62, 249, 0.05))',
      }}
    >
      {/* Title */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={inView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.6 }}
        style={{ textAlign: 'center', marginBottom: '64px' }}
      >
        <h2 style={{ fontSize: '2.5rem', fontWeight: '700', marginBottom: '16px', lineHeight: 1.2 }}>
          Let's Connect &{' '}
          <span style={{ background: 'linear-gradient(to right, #8b5cf6, #ec4899)', WebkitBackgroundClip: 'text', color: 'transparent' }}>
            Create Together
          </span>
        </h2>
        <p style={{ fontSize: '1.125rem', color: '#888888', marginBottom: '8px' }}>
          Ready to transform your business networking?
        </p>
        <p style={{ fontSize: '1.125rem', color: '#888888', maxWidth: '800px', margin: '0 auto' }}>
          Experience the power of NFC technology with custom-designed cards tailored to your needs. Get in touch today and take your business to new heights.
        </p>
      </motion.div>

      {/* Grid: Form + Info Cards */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
        gap: '32px',
        maxWidth: '1200px',
        margin: '0 auto',
      }}>
        {/* Contact Form */}
        <motion.form
          onSubmit={handleSubmit}
          initial={{ opacity: 0, x: -50 }}
          animate={inView ? { opacity: 1, x: 0 } : {}}
          transition={{ delay: 0.2, duration: 0.8 }}
          style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}
        >
          {['name', 'email', 'phone'].map((field, i) => (
            <div key={field}>
              <label style={{ display: 'block', fontWeight: '600', marginBottom: '6px', fontSize: '0.875rem' }}>
                {field === 'name' ? 'Full Name' : field === 'email' ? 'Email Address' : 'Phone Number'}
              </label>
              <input
                type={field === 'email' ? 'email' : 'text'}
                name={field}
                value={formData[field]}
                onChange={handleChange}
                required={field !== 'phone' ? true : false}
                placeholder={field === 'name' ? 'John Doe' : field === 'email' ? 'john@example.com' : '+1 (555) 123-4567'}
                style={{
                  width: '100%',
                  padding: '12px',
                  borderRadius: '16px',
                  border: '1px solid #e5e7eb',
                  background: '#fff',
                  fontSize: '1rem',
                  outline: 'none',
                }}
              />
            </div>
          ))}

          <div>
            <label style={{ display: 'block', fontWeight: '600', marginBottom: '6px', fontSize: '0.875rem' }}>
              Message
            </label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
              rows={5}
              placeholder="Tell us about your needs..."
              style={{
                width: '100%',
                padding: '12px',
                borderRadius: '16px',
                border: '1px solid #e5e7eb',
                background: '#fff',
                fontSize: '1rem',
                outline: 'none',
                resize: 'none',
              }}
            />
          </div>

          <motion.button
            type="submit"
            disabled={isSubmitting}
            whileHover={{ scale: isSubmitting ? 1 : 1.02, y: isSubmitting ? 0 : -2 }}
            whileTap={{ scale: isSubmitting ? 1 : 0.98 }}
            style={{
              padding: '16px',
              borderRadius: '16px',
              border: 'none',
              background: 'linear-gradient(to right, #8b5cf6, #ec4899)',
              color: '#fff',
              fontWeight: '600',
              fontSize: '1rem',
              cursor: isSubmitting ? 'not-allowed' : 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
            }}
          >
            {isSubmitting ? (
              <span>Sending...</span>
            ) : (
              <>
                Send Message <Send style={{ width: '20px', height: '20px' }} />
              </>
            )}
          </motion.button>
        </motion.form>

        {/* Info Cards */}
        <motion.div
          initial={{ opacity: 0, x: 50 }}
          animate={inView ? { opacity: 1, x: 0 } : {}}
          transition={{ delay: 0.4, duration: 0.8 }}
          style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}
        >
          {infoCards.map((card, index) => {
            const Icon = card.icon;
            return (
              <motion.div
                key={card.title}
                initial={{ opacity: 0, y: 20 }}
                animate={inView ? { opacity: 1, y: 0 } : {}}
                transition={{ delay: 0.5 + index * 0.1 }}
                whileHover={{ x: 8, scale: 1.02 }}
                style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '16px',
                  padding: '24px',
                  borderRadius: '16px',
                  border: '1px solid #e5e7eb',
                  background: '#fff',
                  boxShadow: '0 8px 16px rgba(0,0,0,0.05)',
                  position: 'relative',
                }}
              >
                <motion.div
                  whileHover={{ scale: 1.1, rotate: 5 }}
                  transition={{ type: 'spring', stiffness: 300 }}
                  style={{
                    width: '56px',
                    height: '56px',
                    borderRadius: '16px',
                    background: `linear-gradient(to bottom right, ${card.gradient[0]}, ${card.gradient[1]})`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#fff',
                  }}
                >
                  <Icon style={{ width: '100%', height: '100%', color: 'white' }} />
                </motion.div>
                <div>
                  <h3 style={{ fontSize: '1.25rem', fontWeight: '700', marginBottom: '4px' }}>{card.title}</h3>
                  <p style={{ fontSize: '0.875rem', color: '#888888' }}>{card.description}</p>
                </div>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};

export default Contact;

